import { useContext } from "react"
import { useEffect } from "react"
import { db } from "../data/firebase"
import { collection, onSnapshot, query, orderBy } from "firebase/firestore"
import { ConfigsContext } from "../components/ConfigsContext"
import {deleteDoc, doc } from "firebase/firestore"

let globalPrice;

export default function OrderPage( {user} )
{

  const { configs, setConfigs } = useContext(ConfigsContext);

  useEffect(() =>
  {
    if (!user)
      {
        return (
          <div id='main-bg'>
        <p className="tab-button"> loading</p>
        </div>
        )
      }

    const q = query(collection(db, "users", user.uid, "dimensions"));
    const unsubscribe = onSnapshot(q, (snapshot) => 
    {
      const list = snapshot.docs.map(doc => ({id: doc.id, ...doc.data()}));
      setConfigs(list);
    });

    return () => unsubscribe();
  }, [setConfigs]);

  function totalPrice()
  {
    const superPrice = configs.reduce((sum, item) => sum + parseFloat(item.price || 0), 0);

    globalPrice = superPrice.toFixed(2);
    return globalPrice;
  }

  const handleCheckout = async () =>
  {
    try 
    {
      const response = await fetch('/api/create-checkout-session',
        {
          method: 'POST',
          headers:
          {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify( 
            { 
            amount: totalPrice(),
            userId: user.uid
            }
          ),

        });
        const { url } = await response.json();
        if(url)
        {
          window.location.href = url; //redirect to stripe checkout
        }
        else
        {
          throw new Error('No URL returned from the server');
        }

    }
    catch(error)
    {
      console.error("Error: ", error);
    }
  }

  const handleSubmit = async(e) =>
  {
    e.preventDefault();
    await handleCheckout();
  };


  return (
    <div id='main-bg'>

      <main className="tab-button">
        
        <ul>
          {configs.map((item) =>
          (
            <li className="tab-button" key={item.id}>
              -From:{item.from}
              -To:{item.to}

              -{item.weight}lbs
              -{item.length}in
              -{item.width}in
              -{item.height}in
              { item.regular ? <p>Regular</p> : null}
              { item.urgent ? <p>Urgent</p> : null}
              -price: ${item.price}
              <button onClick={async() => 
              {
                try 
                {
                  await deleteDoc(doc(collection(db, "users", user.uid, "dimensions"), item.id));
                }
                catch(error)
                {
                  console.log("Error deleting document: ", error);
                }
              }} className="tab-button"> trash</button>

              </li>
          ))}
        </ul>

        <nav>
          <h3>Total Price: {totalPrice()}</h3>
            <form onSubmit={handleSubmit}>
                <button className='tab-button' type='submit'>
                    Checkout
                </button>
            </form>
        </nav>

      </main>

          <h3> Developer's note* website is not finished and you will not be charged</h3>

   
    </div>
  )
}


export const price = globalPrice;